module.exports = __webpack_public_path__ + "media/application/images/ui/badge-trusted-with-text-xs-1083f64d3ae24bd5de94ab08b7699a82.png";